/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import PropTypes from "prop-types";

function run(Component, t, i18n, language, props) {
  let currentPageLng = props.location.pathname.substring(1);
  let path = "";
  if (currentPageLng.length > 2) {
    path = currentPageLng.substring(2);
    currentPageLng = currentPageLng.substring(0, 2);
  }
  if (currentPageLng.toUpperCase() !== language.toUpperCase()) {
    let link = "/" + language;
    if (path !== "") {
      link += path;
    }
    return (
      <Redirect to={link} {...props} t={t} i18n={i18n} language={language} />
    );
  }
  return <Component {...props} t={t} i18n={i18n} language={language} />;
}

const HomePageRoute = ({ component: Component, ...rest }) => (
  <AuthConsumer>
    {({ t, i18n, language }) => (
      <Route
        render={(props) => run(Component, t, i18n, language, props)}
        {...rest}
      />
    )}
  </AuthConsumer>
);
HomePageRoute.propTypes = {
  component: PropTypes.func,
};

export default HomePageRoute;
